import React from 'react';

export default function MovedBackEvidenceAlert() {
  return (
    <va-alert class="vads-u-padding-bottom--1" status="info" slim>
      We moved your claim back to this step because we needed to find or review
      more evidence.
    </va-alert>
  );
}
